<app-dialog [title]="'Update Repricing Model'" [actions]="actions" 
    (action)="dialogAction($event)" (close)="dialogRef.close()">
    <mat-dialog-content>
        <div class="multi-action" [formGroup]="settingsForm">
            <div class="multi-action_container" formGroupName="Prmodel">
                <div class="input-container">
                    <div class="input-container_label">Repricing Model:</div>
                    <div class="multi-action_reprice">
                        <select class="input-container_input input-container_input--thin hand" formControlName="name">
                            <option *ngFor="let option of options" [value]="option.modelId">
                                {{ option.name }}
                            </option>
                        </select>
                        <div class="multi-action_switch">
                            <app-input-switcher [options]="[
                        { display: 'On', value: true },
                        { display: 'Off', value: false } ]" 
                        formControlName="isActive"></app-input-switcher>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </mat-dialog-content>
</app-dialog>